import React, {
    ReactElement,
} from "react";
import { Form } from "react-bootstrap";
import { BiTrash } from "react-icons/bi";
import { createId, Json } from "./base";

export default function WorkflowServiceUrl({ json, onChange, rootJson }: {
    json: Json;
    onChange: (current: ((json: Json) => Json)) => void;
    rootJson: Json
}): ReactElement {
    const connection = json.connection as Json;
    const changeConnection = (child: Json) => {
        onChange(current => ({
            ...current,
            connection: {
                ...connection,
                ...child,
            },
        }));
    };
    const deleteKey = (key: string) => {
        onChange(current => {
            const copy = { ...current };
            delete (copy.connection as Record<string, string>)[key];
            return copy;
        });
    };

    if (connection?.url) {
        const url = connection?.url as Json | undefined;
        const changeUrl = (child: Json) => {
            changeConnection({
                url: {
                    ...url,
                    ...child,
                },
            });
        };
        return (
            <div>
                <div
                    className="d-flex justify-content-between align-items-start"
                >
                    <h5>Url Config</h5>
                    <button
                        type="button"
                        className="btn btn-none btn-sm p-0 text-light  "
                        onClick={() => deleteKey("url")}
                    >
                        <BiTrash />
                    </button>

                </div>

                <Form.Group className="mb-5">
                    <Form.Label className="fw-bolder">Url</Form.Label>
                    <Form.Control
                        type="url"
                        placeholder="Http://"
                        required
                        onChange={evt => changeUrl({ url: evt.target.value })}
                        value={url?.url as string ?? ""}
                    />
                    <Form.Text>
                        Instructions shown to the end users
                    </Form.Text>
                </Form.Group>

            </div>
        );
    }

    return (
        <button
            type="button"
            className="btn btn-primary py-1 px-2"
            onClick={() => changeConnection({
                id: `urn:fq:workflow-service-connection:(urn:fq:workflow-service:${json.id},${createId()})`,
                ...connection,
                url: {
                },
            })}
        >
            URL
        </button>
    );
}
